<template>
  <div @dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave" @drop.prevent="handleFileDrop($event)">
    <v-card
      @click="$emit('click')"
      width="640px"
      max-height="125"
      height="125"
      align="center"
      :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4'"
      elevation="0"
    >
      <div v-if="isDrag" class="drag fadeIn">
        <v-icon x-large style="zoom: 3" v-if="!isDrop">mdi-file</v-icon>
        <v-icon x-large style="zoom: 3" class="fade" v-else-if="isFailed" color="error">mdi-close</v-icon>
        <v-icon x-large style="zoom: 3" class="fade" v-else color="success">mdi-check-bold</v-icon>
      </div>

      <v-card-text align="center" class="prevent-select">
        <div v-if="!isLoading && !isDrop">
          <v-icon large :color="iconColor">{{ icon }}</v-icon>
          <br />
          {{ $t(displayText) }}
          <br />
        </div>
        <v-progress-circular indeterminate size="70" v-else></v-progress-circular>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import DragMixin from "@/views/sign/DragMixin.vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

/**
 * Component that looks like a button but is a card.
 * Displays an example image which is overwritten by the uploaded one.
 * Displays a loading animation via property.
 */
@Component({})
export default class ImageUploadButton extends mixins(DragMixin) {
  /**
   * Color of the icon.
   */
  @Prop({})
  iconColor?: string;

  /**
   * Icon to be displayed on the button card.
   */
  @Prop({ default: "mdi-camera" })
  icon: any;

  /**
   * Text to be displayed on the button card.
   */
  @Prop({ default: "defaultFoto" })
  text: any;

  /**
   * An alternative text to be displayed on @isUploade
   */
  @Prop({ default: "defaultFotoAgain" })
  textAlt: any;

  /**
   * Indicates wether a given file is uploaded or not.
   * Changes in display behaviour based on this sate, e.g. alt text.
   */
  @Prop({ default: false })
  isUploaded!: boolean;

  /**
   * Indicates wether a given file is currently uploading or not.
   * Changes in display behaviour based on this sate, e.g. loading spinner.
   */
  @Prop({ default: false })
  isLoading!: boolean;

  /**
   * handle drag over event. Do not execute if component is loading
   */
  handleDragOver() {
    if (this.isLoading) {
      return;
    }
    this.dragOver();
  }

  /**
   * handle drag leave event. Do not execute if component is loading
   */
  handleDragLeave(event: DragEvent) {
    if (this.isLoading) {
      return;
    }
    this.dragLeave(event);
  }

  /**
   * handle file drop event. Do not execute if component is loading
   */
  handleFileDrop(event: DragEvent) {
    if (this.isLoading) {
      return;
    }
    this.onFileDrop(event);
  }

  /**
   * Displays either the text of the alternative text based on the upload status.
   */
  get displayText() {
    return this.isUploaded ? this.textAlt : this.text;
  }

  onDrop(file: File) {
    this.$emit("onDrop", file);
  }
}
</script>

<style>
.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>
